module.exports = __webpack_public_path__ + "img/14_newModelWorker_wxc.f5f385a6.png";